export const TAB_BAR_MIN_HEIGHT = 55;
export const ANDROID_NAV_BAR_BOTTOM_INSET_FALLBACK = 16;

type GetTabBarSafeAreaStyleArgs = {
  isAndroidDevice: boolean;
  safeAreaBottomInset: number;
};

type GetTabBarItemSafeAreaStyleArgs = Pick<GetTabBarSafeAreaStyleArgs, 'isAndroidDevice'>;

export const getTabBarSafeAreaStyle = ({
  isAndroidDevice,
  safeAreaBottomInset,
}: GetTabBarSafeAreaStyleArgs) => {
  if (!isAndroidDevice) {
    return undefined;
  }

  const bottomInset = Math.max(safeAreaBottomInset, ANDROID_NAV_BAR_BOTTOM_INSET_FALLBACK);

  return {
    height: TAB_BAR_MIN_HEIGHT + bottomInset,
    paddingBottom: bottomInset,
  };
};

export const getTabBarItemSafeAreaStyle = ({ isAndroidDevice }: GetTabBarItemSafeAreaStyleArgs) => {
  if (!isAndroidDevice) {
    return undefined;
  }

  return {
    height: TAB_BAR_MIN_HEIGHT,
  };
};
